/**
 * @author       tae@zumper.com (Tae Yoon)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Detail entity reducer
 */

import { nullReducer, payloadKeyReducer } from '@zcode/reducers'
import type { EntityWithMeta } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { CLEAR_ENTITY, RECEIVE_ENTITY } from '../constants/index'
import { meta } from './meta'
import type { ActionTypes } from './types'

export const entityReducer = combineReducers<EntityWithMeta, ActionTypes>({
  data: handleActions<EntityWithMeta['data'], ActionTypes>(
    {
      [CLEAR_ENTITY]: nullReducer,
      [RECEIVE_ENTITY]: payloadKeyReducer('entity'),
    },
    null
  ),
  meta,
})
